import { AspectRatioValue } from './constants';

const SESSION_STORAGE_UPLOAD_PREFERENCES_KEY = 'upload_preferences';

export type UploadPreferences = {
  /**
   * Full list of custom brand colours chosen in the simplified upload flow. The backend derives
   * the single colour it needs (currently the first entry) from this list.
   */
  colours?: string[];
  font_location?: string;
  aspect_ratios?: AspectRatioValue[];
};

export const getLocalUploadPreferences = (contentId?: string): UploadPreferences | undefined => {
  if (!contentId) {
    return undefined;
  }

  return JSON.parse(sessionStorage.getItem(SESSION_STORAGE_UPLOAD_PREFERENCES_KEY) || '{}')[
    contentId || ''
  ] as UploadPreferences;
};

export const storeLocalUploadPreferences = (contentId: string, preferences: UploadPreferences) => {
  const localUploadPreferences = JSON.parse(sessionStorage.getItem(SESSION_STORAGE_UPLOAD_PREFERENCES_KEY) || '{}');
  localUploadPreferences[contentId] = preferences;
  sessionStorage.setItem(SESSION_STORAGE_UPLOAD_PREFERENCES_KEY, JSON.stringify(localUploadPreferences));
};
